module.exports = __webpack_public_path__ + "media/images/PrepWorks-Logo_300-5999dff4884917a78972424773fc9ad0.png";